import type { Partner_Partner as Partner } from '__generated__/graphql-types';

import path from 'js/lib/path';

import { isPartnersPageMigrationEnabled } from 'bundles/partners-graphql/utils/experiments';

export function getPartnerPageUrl(partner: Pick<Partner, 'homePageOverride' | 'slug'>) {
  if (partner.homePageOverride) {
    return partner.homePageOverride;
  } else {
    return isPartnersPageMigrationEnabled() ? path.join('/partners', partner.slug) : path.join('/', partner.slug);
  }
}
